export const colors = {
  brand: '#0053a5',
  brandDark: '#1d4ed8',
  brandDarker: '#1e40af',
  brandHover: '#004f85',
  brandSoft: '#dfedf7',
  brandSofter: '#e7f2fa',
  brandSubtle: '#edf8fe',

  textPrimary: '#111827',
  textSecondary: '#4b5563',
  textMuted: '#6b7280',
  textSubtle: '#010306',
  textHeading: '#142235',
  textDark: '#232a31',
  textPlaceholder: '#a7b0bb',
  textInverse: '#ffffff',
  textLink: '#0053a5',

  surfacePage: '#f5f6fa',
  surfaceSoft: '#f8fafc',
  surfaceSofter: '#f3f8fb',
  surfaceCard: '#ffffff',
  surfaceHover: '#eff6ff',
  surfaceHoverLight: '#f8fcff',
  surfaceHoverSoft: '#f5fbff',
  surfaceSelected: '#dbeafe',
  surfaceControl: '#f4f8fb',
  surfaceRowAlt: '#fbfdff',

  border: '#e6f0ff',
  borderLight: '#eef3f8',
  borderSofter: '#f0f0f0',
  borderMuted: '#d8e4ef',
  borderInput: '#d5dde5',
  borderFocus: '#7dbce6',
  borderHover: '#99c7e8',
  controlBorder: '#77abd0',
  controlBorderMuted: '#e7edf3',
  controlAccent: '#4f9ac7',

  iconMuted: '#d1d5db',
  iconSubtle: '#9aa6b2',
  iconNeutral: '#8c8c8c',
  iconSoft: '#bbbbbb',
  scrollbarThumb: '#c4ccd8',
  scrollbarThumbLight: '#d1d5db',
  danger: '#dc2626',
  dangerSoft: '#ef4444',
  dangerStrong: '#e11d24',
  success: '#15803d',
  successSoft: '#16a34a',
  warning: '#f97316',
  info: '#3b82f6',
  transparent: 'transparent',

  statusNeutralBg: '#f1f3ee',
  statusNeutralText: '#717b36',
  statusProcessingBg: '#f6f4f7',
  statusProcessingText: '#273048',
  statusProcessingBorder: '#d4d8dd',
  statusWarningBg: '#fff7ea',
  statusWarningText: '#bf7328',

  shadowMenu: 'rgba(15, 35, 55, 0.08)',
  shadowBadge: 'rgba(26, 95, 145, 0.08)',
  shadowTag: 'rgba(39, 51, 70, 0.05)',
  shadowAvatar: 'rgba(57, 77, 103, 0.12)',
  shadowDropdown: '0 6px 16px 0 rgba(0, 0, 0, .08), 0 3px 6px -4px rgba(0, 0, 0, .12), 0 9px 28px 8px rgba(0, 0, 0, .05)',
  avatarBlueBg: '#eaf3ff',
  avatarBlueText: '#142235',
  avatarPurpleBg: '#f2eaff',
  avatarMoreBg: '#eef6ff',
  avatarMoreText: '#0053a5',

  avatarNeutralBg: '#d9d9d9',
  avatarNeutralText: '#555555',
  avatarIndigo: '#6366f1',
  avatarPurple: '#8b5cf6',
  avatarBlue: '#3b82f6',
  avatarGreen: '#10b981',
  linkedIn: '#0077b5',
};

export const typographyColors = {
  primary: colors.textPrimary,
  secondary: colors.textSecondary,
  muted: colors.textMuted,
  subtle: colors.textSubtle,
  inverse: colors.textInverse,
  link: colors.textLink,
  danger: colors.danger,
  success: colors.success,
};

export const onboardingStageToneColors = {
  approved: {
    background: '#f2f2e8',
    text: '#79772d',
  },
  danger: {
    background: '#fde7e9',
    text: colors.danger,
  },
  issued: {
    background: '#e9f2fb',
    text: colors.textLink,
  },
  neutral: {
    background: colors.surfaceSoft,
    text: colors.textSecondary,
  },
  success: {
    background: '#e7f5ee',
    text: colors.success,
  },
  warning: {
    background: '#fbf0e7',
    text: colors.warning,
  },
};

export const colorVars = {
  brand: 'var(--color-brand)',
  brandDark: 'var(--color-brand-dark)',
  brandDarker: 'var(--color-brand-darker)',
  brandHover: 'var(--color-brand-hover)',
  brandSoft: 'var(--color-brand-soft)',
  brandSofter: 'var(--color-brand-softer)',
  brandSubtle: 'var(--color-brand-subtle)',

  textPrimary: 'var(--color-text-primary)',
  textSecondary: 'var(--color-text-secondary)',
  textMuted: 'var(--color-text-muted)',
  textSubtle: 'var(--color-text-subtle)',
  textHeading: 'var(--color-text-heading)',
  textDark: 'var(--color-text-dark)',
  textPlaceholder: 'var(--color-text-placeholder)',
  textInverse: 'var(--color-text-inverse)',
  textLink: 'var(--color-text-link)',

  surfacePage: 'var(--color-surface-page)',
  surfaceSoft: 'var(--color-surface-soft)',
  surfaceSofter: 'var(--color-surface-softer)',
  surfaceCard: 'var(--color-surface-card)',
  surfaceHover: 'var(--color-surface-hover)',
  surfaceHoverLight: 'var(--color-surface-hover-light)',
  surfaceHoverSoft: 'var(--color-surface-hover-soft)',
  surfaceSelected: 'var(--color-surface-selected)',
  surfaceControl: 'var(--color-surface-control)',
  surfaceRowAlt: 'var(--color-surface-row-alt)',

  border: 'var(--color-border)',
  borderLight: 'var(--color-border-light)',
  borderSofter: 'var(--color-border-softer)',
  borderMuted: 'var(--color-border-muted)',
  borderInput: 'var(--color-border-input)',
  borderFocus: 'var(--color-border-focus)',
  borderHover: 'var(--color-border-hover)',
  controlBorder: 'var(--color-control-border)',
  controlBorderMuted: 'var(--color-control-border-muted)',
  controlAccent: 'var(--color-control-accent)',

  iconMuted: 'var(--color-icon-muted)',
  iconSubtle: 'var(--color-icon-subtle)',
  iconNeutral: 'var(--color-icon-neutral)',
  iconSoft: 'var(--color-icon-soft)',
  scrollbarThumb: 'var(--color-scrollbar-thumb)',
  scrollbarThumbLight: 'var(--color-scrollbar-thumb-light)',
  danger: 'var(--color-danger)',
  dangerSoft: 'var(--color-danger-soft)',
  dangerStrong: 'var(--color-danger-strong)',
  success: 'var(--color-success)',
  successSoft: 'var(--color-success-soft)',
  warning: 'var(--color-warning)',
  info: 'var(--color-info)',
  transparent: 'var(--color-transparent)',
  linkedIn: 'var(--color-linkedin)',

  statusNeutralBg: 'var(--color-status-neutral-bg)',
  statusNeutralText: 'var(--color-status-neutral-text)',
  statusProcessingBg: 'var(--color-status-processing-bg)',
  statusProcessingText: 'var(--color-status-processing-text)',
  statusProcessingBorder: 'var(--color-status-processing-border)',
  statusWarningBg: 'var(--color-status-warning-bg)',
  statusWarningText: 'var(--color-status-warning-text)',

  shadowMenu: 'var(--color-shadow-menu)',
  shadowBadge: 'var(--color-shadow-badge)',
  shadowTag: 'var(--color-shadow-tag)',
  shadowAvatar: 'var(--color-shadow-avatar)',
  shadowDropdown: 'var(--color-shadow-dropdown)',
  avatarBlueBg: 'var(--color-avatar-blue-bg)',
  avatarBlueText: 'var(--color-avatar-blue-text)',
  avatarPurpleBg: 'var(--color-avatar-purple-bg)',
  avatarMoreBg: 'var(--color-avatar-more-bg)',
  avatarMoreText: 'var(--color-avatar-more-text)',
};
